import { createAppRouter } from "@/app/router";
import { QueryClient } from "@tanstack/react-query";

export const appRouter = createAppRouter();
export const queryClient = new QueryClient();
